import { render, staticRenderFns } from "./DownloadList.vue?vue&type=template&id=30561cf3&scoped=true&"
import script from "./DownloadList.vue?vue&type=script&lang=js&"
export * from "./DownloadList.vue?vue&type=script&lang=js&"
import style0 from "./DownloadList.vue?vue&type=style&index=0&id=30561cf3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30561cf3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30561cf3')) {
      api.createRecord('30561cf3', component.options)
    } else {
      api.reload('30561cf3', component.options)
    }
    module.hot.accept("./DownloadList.vue?vue&type=template&id=30561cf3&scoped=true&", function () {
      api.rerender('30561cf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/DownloadList.vue"
export default component.exports